/*
 * assets/js/src/form-preselect.js — předvybraný program v poptávce.
 *
 * ---------------------------------------------------------------------
 * PROČ TENHLE MODUL VZNIKL: TICHÁ ZTRÁTA FUNKCE V KROKU 12
 * ---------------------------------------------------------------------
 * Legacy `main.js` předvyplňuje select programu takhle:
 *
 *     $(".event-detail").length && $('[data-type="event"] select').val($("h1").text())
 *
 * Brána je `.event-detail` — třída, kterou nový detail programu
 * nevypisuje. Po kroku 12 tedy formulář na stránce programu přestal
 * vědět, ke kterému programu patří, a nic to neohlásilo: select se
 * vykreslil, jen prázdný („Žádný vybraný program").
 *
 * Změřeno 17. 9. i s kontrolou: na detailu LOKALITY, kterého se krok 12
 * nedotkl, tatáž větev legacy pořád funguje (`.location-detail` je tam
 * a select má „Dvůr Hoffmeister"). Stejný kód, jiný výsledek — tedy
 * chybí značka, ne knihovna.
 *
 * ---------------------------------------------------------------------
 * PROČ NE ZPÁTKY `.event-detail`, A PROČ NE `selected` V PHP
 * ---------------------------------------------------------------------
 * Vrátit `.event-detail` by znamenalo vypsat legacy třídu jen kvůli
 * jedné větvi cizí funkce. (Ověřeno, že v `main.js` na ni visí právě
 * ta jedna věc a v `main.css` nic — ale je to pořád cizí brána,
 * kterou by nikdo příště nečekal.)
 *
 * Vypsat `selected` na `<option>` v PHP by předvýběr rozšířilo i na běh
 * BEZ JavaScriptu. To zní jako vylepšení a je to porušení kontraktu:
 * payload nové šablony se musí rovnat payloadu parity, a parita bez JS
 * neposílá `SelectedEvent[]` vůbec. Že předvýběr bez JS nefunguje, je
 * DLUH PARITY — zapisuje se, neopravuje se tady (kontrakt §4).
 *
 * Modul proto dělá přesně to co legacy, jen na naší značce.
 */

/*
 * DVA ATRIBUTY, JEDEN MODUL (doplněno 17. 9., krok detailu lokality).
 * Detail programu předvybírá program, detail lokality lokalitu —
 * a legacy brána `.location-detail`, kterou k tomu používá parita,
 * se v nové vrstvě vypsat nesmí (zapnula by nad stránkou i legacy obsluhu).
 */
const ROOT = '[data-za-program], [data-za-lokalita]';

/**
 * Vybere v selectu možnost se shodným textem. Porovnává se HODNOTA
 * možnosti, protože přesně ta odchází na server — legacy dělá `.val()`
 * z téhož důvodu.
 *
 * @param {HTMLElement} root Prvek nesoucí `data-za-program`.
 * @returns {boolean} Jestli se opravdu něco vybralo.
 */
function predvyber(root) {
	const nazev = (root.getAttribute('data-za-program') || root.getAttribute('data-za-lokalita') || '').trim();
	if (!nazev) return false;

	const select = document.querySelector('[data-type="event"] select, [data-type="location"] select');
	if (!select) return false;

	let sedlo = false;
	for (const opt of select.options) {
		if (opt.value === nazev) {
			opt.selected = true;
			sedlo = true;
		}
	}
	if (!sedlo) return false;

	/*
	 * `change` se posílá schválně: legacy selectric se inicializuje
	 * asynchronně (`pagerequirejs(["selectric"])`) a při inicializaci
	 * čte aktuální hodnotu. Když už proběhl, `change` ho donutí překreslit
	 * popisek. Bez události by hodnota v payloadu seděla, ale uživatel by
	 * viděl „Žádný vybraný program" — tedy formulář, který tvrdí něco
	 * jiného, než odešle.
	 */
	select.dispatchEvent(new window.Event('change', { bubbles: true }));
	return true;
}

/**
 * Spustí modul. Vrací počet předvyborů (0 nebo 1).
 *
 * @returns {number}
 */
export function init() {
	const root = document.querySelector(ROOT);
	if (!root) return 0;
	return predvyber(root) ? 1 : 0;
}
